import { render } from "./MassaratsManagement.vue?vue&type=template&id=1e47314d&scoped=true"
import script from "./MassaratsManagement.vue?vue&type=script&lang=js"
export * from "./MassaratsManagement.vue?vue&type=script&lang=js"

import "./MassaratsManagement.vue?vue&type=style&index=0&id=1e47314d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e47314d"]])

export default __exports__